var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFa = function SvgFa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31.099,
    height: 31.099,
    x: 0.68,
    y: 0.511,
    fill: "#fff",
    rx: 15.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fa_svg__a)",
    fillRule: "evenodd",
    d: "M-5.543.511h43.539v31.1H-5.543z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fa_svg__b)",
    fillRule: "evenodd",
    d: "M-5.543 10.877h43.539v10.366H-5.543z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF1818",
    fillRule: "evenodd",
    d: "M-5.543 21.244h43.539V31.61H-5.543z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#25844C",
    fillRule: "evenodd",
    d: "M-5.543.511h43.539v10.366H-5.543z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#BE1931",
    d: "M17.783 12.757c.984.504 3.124 3.036.82 5.893 1.431-.317 3.252-4.533-.82-5.893m-3.02 0c-4.07 1.36-2.25 5.576-.82 5.893-2.304-2.857-.164-5.39.82-5.893m1.494-.147c.041.202 1.132.448 1.002-.59-.173.42-.673.408-.995.213-.445.248-.86.188-1.016-.233-.153.775.603 1.003 1.01.61"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#BE1931",
    d: "M18.886 15.775c-.015-1.283-.696-2.419-1.366-2.878.442.542 1.801 3.533-.807 5.502l.048-5.241-.488-.43-.489.41.082 5.29-.018-.015c-2.636-1.968-1.268-4.973-.825-5.516-.67.46-1.352 1.595-1.367 2.878-.013 1.101.491 2.306 1.886 3.295a6.6 6.6 0 0 1-1.725.207c.477.26 1.378.198 2.064.135v.07l.41.45.411-.469v-.053c.691.064 1.612.133 2.097-.132-.601.01-1.2-.064-1.781-.219 1.382-.988 1.882-2.187 1.868-3.284"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fa_svg__a",
    x1: 451.615,
    x2: 451.615,
    y1: 0.511,
    y2: 466.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fa_svg__b",
    x1: 451.615,
    x2: 451.615,
    y1: 10.877,
    y2: 166.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })))));
};
export default SvgFa;